import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../endpoints";
import * as adminAnalyticsActions from "../actions/admin_analytics_actions";
import * as adminAnalyticsTypes from "../types/admin_analytics_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getAccountsSummaryCount(action) {
  try {
    const res = yield call(api.get, endpoints.SUPER_ADMIN_ACCOUNTS_SUMMARY_COUNT, action.payload);
    if (res.status === 200) {
      yield put(adminAnalyticsActions.getAccountsSummaryCountSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(adminAnalyticsActions.getAccountsSummaryCountError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(adminAnalyticsActions.getAccountsSummaryCountError(e));
  }
}

export default function* adminAnalyticsSaga() {
  yield takeLatest(adminAnalyticsTypes.getAccountsSummaryCount.GET_ACCOUNTS_SUMMARY_COUNT_REQUEST, getAccountsSummaryCount);
}
